import { render } from "./ExperimentFiles.vue?vue&type=template&id=49f449da&scoped=true"
import script from "./ExperimentFiles.vue?vue&type=script&lang=js"
export * from "./ExperimentFiles.vue?vue&type=script&lang=js"

import "./ExperimentFiles.vue?vue&type=style&index=0&id=49f449da&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f449da"]])

export default __exports__